import $ from "jquery";

export function removeCkReset(element) {
  let current = $(element);
  while (current && current.length > 0) {
    current.removeClass("ck-reset");
    current.removeClass("ck-reset_all");
    current = current.parent();
  }
}
